import req from "@/utils/axios.js";
export default {
    // 门店进货商品列表
    getstoreshoplist(data){
        return req.get("/wxShop/product/list",{
            ...data
        })
    },
    //分类
    getshopcategory(){
        return req.get("/wxShop/product/category/list")
    },
    //购物车库存
    getSkuStockAndStatus(data){
        return req.post("/wxShop/product/getSkuStockAndStatus",{
            ...data
        })
    },
    //价格计算
    calculatePrice(data){
        return req.post("/wxShop/order/calculate",{
            ...data
        })
    },
    //提交进货订单
    createOrder(data){
        return req.post("/wxShop/order/submit",{
            ...data
        })
    }
}